import { useCallback, useEffect, useMemo, useState } from 'react'
import { isDesktop } from '../../../client'
import { Container } from './Ozen.styles'
import { AdId, usePage } from '../../../contexts'
import Ad, { SizeMap, SizeMapItem } from '../../../sharedComponnets/Ads/Ad'

type IOzenProps = {
  side: 'left' | 'right'
}

const sizeMap: SizeMap = [
  {
    screen: [1610, 0],
    ad: [120, 600],
  },
  {
    screen: [1690, 0],
    ad: [160, 600],
  },
  {
    screen: [1970, 0],
    ad: [300, 600],
  },
]
export const Ozen = ({ side }: IOzenProps) => {
  const page = usePage()
  const [shouldRender, setShouldRender] = useState(false)
  const [adSize, setAdSize] = useState<number[]>([])
  const [sizeMapItem, setSizeMapItem] = useState<SizeMapItem | undefined>()
  const [filteredSizeMap, setFilteredSizeMap] = useState<SizeMap | null>(null)
  const id = useMemo(() => `Ozen_${side}` as AdId, [side])

  useEffect(() => {
    // Only render on desktop
    setShouldRender(isDesktop())
  }, [])

  const onRender = useCallback(
    (event: googletag.events.SlotRenderEndedEvent) => {
      if (!Array.isArray(event.size)) {
        return
      }
      setAdSize(event.size)
      return () => null
    },
    []
  )

  useEffect(() => {
    const hasWarComp = !!page?.PageMeta.war_comp
    const w = (window.innerWidth - 1290) / 2
    let tempSizeMap = sizeMap.filter(t => t.ad[0] <= w)
    if (hasWarComp) {
      tempSizeMap = tempSizeMap.filter(t => t.ad[0] < 300)
    }
    setFilteredSizeMap(tempSizeMap)
  }, [page?.PageMeta.war_comp])

  useEffect(() => {
    const s = filteredSizeMap
      ? sizeMap.find(t => t.ad[0] === adSize[0] && t.ad[1] === adSize[1])
      : undefined
    setSizeMapItem(s)
  }, [adSize, filteredSizeMap])

  if (!shouldRender || !side || !filteredSizeMap || !id) {
    return null
  }

  return (
    <Container side={side} size={sizeMapItem}>
      <Ad
        id={id}
        sizeMap={filteredSizeMap}
        onRender={event => onRender(event)}
      />
    </Container>
  )
}
